export const ECLocationBoxStyle = {
  '& .MuiAutocomplete-root .MuiOutlinedInput-root': {
    padding: '0px 9px',
    gap: '0px',
    borderRadius: '10px',
    opacity: 1,
    border: '1px solid #65308FCC',
    color: '#7C63A9',
    '&:focus': {
      outline: 'none',
    },
  },

  '& .MuiAutocomplete-root .MuiOutlinedInput-root.Mui-focused': {
    outline: 'none',
    border: '1px solid #65308FCC',
  },

  '& .MuiAutocomplete-input::placeholder': {
    textAlign: 'left',
    color: '#7C63A9',
  },

  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  }
};

export const AppBarBoxStyle = {
  '& .MuiToolbar-root ': {
    paddingRight: '0px',
    paddingLeft: '0px',
    marginInline: '4rem',
    '@media (min-width: 1728px)': {
      margin: 'auto',
    },
    '@media (max-width: 640px)': {
      marginInline: '2rem',
    },
    maxWidth: '93rem',
  },

  '& .MuiPaper-root-MuiAppBar-root': {
    '@media (min-width: 1728px)': {
      height: '150px',
    },
  },
};
